import OFFSET_SCROLL from '../utils/constants';
import isMobile from '../utils/is-mobile';

const scrollingOffset = OFFSET_SCROLL;
const inpageNavigationTitle = '.inpage-navigation__title';
const navigationItemActiveClass = 'inpage-navigation__item--active';
const navigationLinkClass = 'inpage-navigation__link';
const navigationLinkActiveClass = `${navigationLinkClass}--active`;
const inpageNavigationExpanded = 'inpage-navigation--expanded';
const navigationInSidebar = '.node__sidebar > .inpage-navigation';
// so far only PT Product line has this special case
// @todo recheck sometime in the future
const navigationInContent =
  '.node__content .product__header-wrapper > .inpage-navigation';

const inpageNavigation = document.querySelector(navigationInSidebar);
const inpageNavigationProductLine = document.querySelector(navigationInContent);
let inpageNavigationSections = document.querySelectorAll(
  '.inpage-navigation__section',
);
let collapsedHeight = 0;
let mobileToggleOpen = false;
let onMobile = isMobile();
let isSectionNavigation = false;
let windowWidth = window.innerWidth;

const windowScrollTop = () =>
  window.scrollY || document.documentElement.scrollTop;
const offsetTop = (element) => {
  // can't use element.offsetTop bc 'expert-contact' returns 0 (overflow)
  return Math.round(element.getBoundingClientRect().top) + window.scrollY;
};

const getActiveSection = () => {
  let current = -1;
  const sections = [];
  let general = false;

  inpageNavigationSections =
    [...document.querySelectorAll('.inpage-navigation__section')] ?? [];
  inpageNavigationSections.forEach((section, idx) => {
    // section navigation on the front page
    // doesn't include the expert contact
    if (isSectionNavigation && section.id === 'expert-contact') {
      return;
    }

    const scrollTop = windowScrollTop();
    const sectionOffsetTop = offsetTop(section) - scrollingOffset;

    if (
      scrollTop <= sectionOffsetTop &&
      (section.id === 'general' || idx === 0)
    ) {
      general = true;
    } else if (scrollTop >= sectionOffsetTop && section.id !== '') {
      current += 1;
      sections[current] = section.id;
    }
  });

  return general ? 'general' : sections[current];
};

const setActiveLink = (key) => {
  const inpageNavigationLinks = [
    ...inpageNavigation.querySelectorAll(`.${navigationLinkClass}`),
  ];
  const activeLink = document.querySelector(
    `.${navigationLinkClass}[href="#${key}"]`,
  );
  if (activeLink && !activeLink.classList.contains(navigationLinkActiveClass)) {
    inpageNavigationLinks.forEach((link) => {
      link.classList.remove(navigationLinkActiveClass);
      link.parentNode.classList.remove(navigationItemActiveClass);
    });
    activeLink.classList.add(navigationLinkActiveClass);
    activeLink.parentNode.classList.add(navigationItemActiveClass);
  }
};

const scrollSpy = () => {
  const currentSection = getActiveSection();
  setActiveLink(currentSection);
};

const mobileToggle = (addClickListener) => {
  const navigations = [...document.querySelectorAll('.inpage-navigation')];

  // add listeners on both navigations so they work after resize
  if (addClickListener) {
    navigations.forEach((navigation) => {
      // I ran out of variable names and a will to care :/
      // I'll fix it @todo
      const navTitle = navigation.querySelector(inpageNavigationTitle);

      if (navTitle) {
        navTitle.addEventListener('click', ({ target }) => {
          const nav = target.closest('.inpage-navigation');
          // get/update collapsed height
          collapsedHeight = getComputedStyle(
            nav.querySelector(inpageNavigationTitle),
          ).getPropertyValue('--navigation-height');

          if (mobileToggleOpen) {
            nav.style.maxHeight = collapsedHeight;
            nav.classList.remove(inpageNavigationExpanded);
            mobileToggleOpen = false;
          } else {
            nav.style.maxHeight = `${nav.scrollHeight}px`;
            nav.classList.add(inpageNavigationExpanded);
            mobileToggleOpen = true;
          }
        });
      }
    });
  }
};

(() => {
  if (inpageNavigation) {
    // check if  we're on the front page which has section navigation
    // (but uses the same code)
    isSectionNavigation =
      inpageNavigation.classList.contains('section-navigation');

    // add scroll listener
    window.addEventListener('scroll', scrollSpy);

    // add click event for mobile
    mobileToggle(true);
  }
})();

if (inpageNavigation) {
  window.addEventListener('resize', () => {
    if (window.innerWidth !== windowWidth) {
      // update the window width for next time
      windowWidth = window.innerWidth;
      // update the on mobile check
      onMobile = isMobile();

      // reset, to make sure we have the correct values
      if (onMobile) {
        collapsedHeight = 0;
        mobileToggleOpen = false;

        if (inpageNavigationProductLine) {
          inpageNavigationProductLine.classList.remove(
            inpageNavigationExpanded,
          );
          inpageNavigationProductLine.style.maxHeight = '';
        }

        mobileToggle(false);
      }
    }
  });
}
